import type { RemoveCompanyDomainData } from 'api/dist/routes/organization/[organization_id]/company-domain/[domain_id]/index.js'
import type { IApi } from '@/setup/api-client'
import { useApiMutation } from '@/utils/api/api-mutation'
import { useApiToolbox } from '@/utils/api/use-api-toolbox'
import { GetCompanyDomainQuery } from '@/api/organization/company-domain/get-company-domain-query'

export interface IRemoveCompanyDomainParams {
    organizationId: string
    domainId: string
}

export type IRemoveCompanyDomainResult = RemoveCompanyDomainData

/** Removes one exact Clerk domain without sending any domain attributes in the payload. */
export class RemoveCompanyDomainMutation {
    static call(api: IApi, params: IRemoveCompanyDomainParams) {
        return api
            .delete<
                RemoveCompanyDomainData,
                Record<string, never>
            >(`/organization/${params.organizationId}/company-domain/${encodeURIComponent(params.domainId)}`, {})
            .then((response) => response.data)
    }
}

/** Keeps status invalidation pinned to the workspace used for this mutation. */
export function getRemoveCompanyDomainInvalidation(params: IRemoveCompanyDomainParams) {
    return {
        queryKey: GetCompanyDomainQuery.getKey({ organizationId: params.organizationId }),
        refetchType: 'none' as const,
    }
}

/** Mutates an explicitly prepared workspace-domain pair and marks its live Clerk status stale. */
export function useRemoveCompanyDomainMutation() {
    const { api, qc } = useApiToolbox()

    return useApiMutation<IRemoveCompanyDomainResult, IRemoveCompanyDomainParams>({
        mutationFn: (params) => RemoveCompanyDomainMutation.call(api, params),
        onSuccess: (_result, params) => qc.invalidateQueries(getRemoveCompanyDomainInvalidation(params)),
    })
}
